import { graphql } from 'react-relay';

/**
 * Full cross-tenant detail for one vault: members and their roles (with last
 * login), plan and status, whether the server would accept a Complimentary Pro
 * grant (`canGrant`), Complimentary Pro standing and grant history
 * (operator-only — it names staff and their reasons), rollout ring, feature
 * overrides and creation date.
 * Also pulls the flag catalogue (`featureFlags`) so the detail view can offer an
 * override control for every known flag, not just the ones already pinned.
 *
 * `vaultDetail` is null when no vault has the id. The read itself is recorded
 * against the operator principal server-side (capture only). Read-only — the
 * ring/override writes go through `vault-toggle-mutations`, grant/revoke through
 * `pro-grant-mutations`.
 */
export const vaultDetailQuery = graphql`
    query vaultDetailQuery($vaultId: UUID!) {
        vaultDetail(vaultId: $vaultId) {
            vaultId
            name
            identifier
            jurisdiction
            ring
            createdUtc
            planName
            subscriptionStatus
            planBucket
            canGrant
            complimentary {
                isComplimentary
                complimentaryUntil
                lastGrant {
                    operator
                    term
                    reason
                    occurredUtc
                }
                lastRevoke {
                    operator
                    term
                    reason
                    occurredUtc
                }
                revokedEarly
            }
            members {
                accountId
                email
                roleName
                joinedUtc
                lastLoginUtc
            }
            overrides {
                flagKey
                state
            }
        }
        featureFlags {
            key
        }
    }
`;
